import React, { Component } from 'react';
import { View, TouchableOpacity, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isString as _isString, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import {
  LightThemeColors,
  withTheme,
  getThemeImages,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages as getSohoThemeImages } from '../../../Themes/Modes';
import SohoFrameworkTestKeys from '../../../Utils/SohoFrameworkTestKeys';

import styles from './ItemCard.Style';

class ItemCard extends Component {
  getIcon = (icon, sohoImages, images) => {
    if (icon) {
      return _isString(icon) ? images[icon] : icon;
    }
    return sohoImages.ic_business;
  };

  renderCardBody = (description, descriptionPlaceHolder) => {
    const { renderCardBody, descriptionStyle } = this.props;

    if (_isFunction(renderCardBody)) {
      return renderCardBody(description);
    }

    if (!description) {
      return null;
    }

    return (
      <VFText
        placeHolders={descriptionPlaceHolder}
        i18nKey={description}
        style={[styles.secondText, descriptionStyle]}
      />
    );
  };

  render() {
    const {
      onPress,
      icon,
      title,
      description,
      style,
      theme,
      leftIconStyle,
      rightIconStyle,
      leftIconSize,
      rightIconSize,
      titleStyle,
      images,
      descriptionPlaceHolder,
    } = this.props;

    const sohoImages = getSohoThemeImages(theme.name);
    const _images = getThemeImages(theme.name);
    const _icon = this.getIcon(icon, sohoImages, images);

    return (
      <TouchableWithoutFeedback onPress={onPress} testID={title}>
        <View
          style={[styles.cardContainerStyle(theme), style]}
          accessibilityLabel={`${title}${SohoFrameworkTestKeys.ItemCardName}`}
        >
          <View style={styles.icon}>
            <Icon
              style={[styles.leftIcon, leftIconStyle]}
              name={_icon}
              type="image"
              size={leftIconSize || 34}
            />
          </View>
          <View style={styles.text}>
            <VFText style={[styles.topText, titleStyle]} i18nKey={title} />
            {this.renderCardBody(description, descriptionPlaceHolder)}
          </View>
          <View>
            <TouchableOpacity onPress={onPress}>
              <Icon
                style={[styles.arrowIcon, rightIconStyle]}
                name={_images.ic_chevron_right_red}
                type="image"
                size={rightIconSize || 33}
              />
            </TouchableOpacity>
          </View>
        </View>
      </TouchableWithoutFeedback>
    );
  }
}

ItemCard.defaultProps = {
  theme: LightThemeColors,
};

ItemCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  leftIconStyle: ViewPropTypes.style,
  titleStyle: ViewPropTypes.style,
  descriptionStyle: ViewPropTypes.style,
  rightIconStyle: ViewPropTypes.style,
  style: ViewPropTypes.style,
  onPress: PropTypes.func,
  images: PropTypes.object,
  rightIconSize: PropTypes.number,
  leftIconSize: PropTypes.number,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  renderCardBody: PropTypes.func,
  descriptionPlaceHolder: PropTypes.arrayOf(PropTypes.string),
};

export default withTheme(ItemCard);
